<template>
  <div class="tabStyle">
    <div class="tabLabel">
      <div
        class="tabsItem"
        @click="onChange(0)"
        :class="index === 0 ? 'tabsItemActive' : ''"
      >
        快递柜选址案例
      </div>
      <div
        class="tabsItem"
        @click="onChange(1)"
        :class="index === 1 ? 'tabsItemActive' : ''"
      >
        用户销售推荐案例
      </div>
    </div>
    <Tabs v-model="index">
      <TabPane>
        <indexQuick></indexQuick>
      </TabPane>
      <TabPane>
        <indexUser></indexUser>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import indexQuick from "./index-quick-address.vue";
import indexUser from "./index-user-example.vue";
export default {
  components: {
    indexQuick,
    indexUser
  },
  data() {
    return {
      index: 0
    };
  },
  methods: {
    onChange(index) {
      this.index = index;
    }
  }
};
</script>
<style>
.tabStyle .ivu-tabs-ink-bar {
  display: none !important;
}
.tabStyle .ivu-tabs-bar {
  border-bottom: none;
  margin-bottom: 0;
}
.tabStyle .ivu-tabs-nav-scroll {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style scoped>
.tabLabel {
  display: flex;
  justify-content: center;
}
.tabsItem {
  padding: 8px 20px;
  padding-bottom: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tabsItemActive {
  padding: 8px 20px;
  border-bottom: 2px solid #2d8cf0;
}
@media screen and (min-width: 1400px) {
  .tabStyle {
    padding: 15px 0;
    padding-left: 15vw;
    padding-right: 15vw;
  }
}
@media screen and (max-width: 1400px) {
  .contextStyle {
    padding: 10px 0;
    padding-left: 10vw;
    padding-right: 10vw;
  }
}
@media screen and (max-width: 1000px) {
  .contextStyle {
    padding: 5px 0;
    padding-left: 3vw;
    padding-right: 3vw;
  }
}
@media screen and (max-width: 960px) {
  .contextStyle {
    padding: 5px 0;
    padding-left: 4px;
    padding-right: 4px;
    background: chocolate;
  }
}
</style>
